import { FC } from "react";
import { Box, createStyles, makeStyles } from "@material-ui/core";
import { includes } from "lodash";

import { getTermNiceName } from "lib/helpers";
import {
  ALL_30_YEAR_TERMS,
  ALL_LIFE_OF_RIGHTS_TERMS,
} from "services/listings/constants";
import { InvestmentTerm } from "services/listings/types";
import theme from "theme";

interface StyleProps {
  color: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    listingTerm: {
      display: "flex",
      alignItems: "center",
      backgroundColor: ({ color }: StyleProps) => color,
      borderRadius: "24px",
      color: theme.palette.background.default,
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0.5, 1),
      whiteSpace: "nowrap",
    },
  }),
);

export interface ListingTermProps {
  term: InvestmentTerm;
}

const ListingTerm: FC<ListingTermProps> = ({ term }) => {
  const classes = useStyles({
    color: includes([...ALL_LIFE_OF_RIGHTS_TERMS, ...ALL_30_YEAR_TERMS], term)
      ? theme.custom.palette.green.main
      : theme.custom.palette.purple.main,
  });
  return <Box className={classes.listingTerm}>{getTermNiceName(term)}</Box>;
};
export default ListingTerm;
